import { createContext } from 'react';

const SpreedlyCheckoutButtonsContext = createContext(undefined);

export default SpreedlyCheckoutButtonsContext;
